<template>
  <section>
    <div class="bg-light-brown padding-80-80px">
      <div class="container mb-3">
        <div
          :class="
            screen === 'mobile'
              ? 'is-flex is-flex-direction-column-reverse'
              : 'padding-right-70px padding-left-70px'
          "
          class="columns"
        >
          <div
            class="column is-6 is-flex is-flex-direction-column content-center gap-05rem"
          >
            <div
              :class="
                screen === 'mobile'
                  ? 'is-size-3-mobile line-height-60px'
                  : 'text-64px line-height-80px'
              "
              class="has-text-weight-normal has-text-centered-mobile"
            >
              <p>{{ $t('Upgrade Your') }}<br />{{ $t('Jobsearch Today.') }}</p>
            </div>
            <span
              class="has-text-centered-mobile"
              :class="
                screen === 'mobile' ? 'line-height-28px' : 'line-height-32px'
              "
            >
              {{
                $t(
                  'We are here to extend your outreach and ensure your job openings reach the most fitting candidates.'
                )
              }}
            </span>
            <hr class="hr-line has-background-black" />
            <div class="columns is-flex">
              <div class="column">
                <div
                  :class="screen === 'mobile' ? 'text-24px' : 'is-size-3'"
                  class="has-text-centered-mobile"
                >
                  {{ $t('6,500+') }}
                </div>
                <p class="has-text-centered-mobile">
                  {{ $t('employed Jobseeker') }}
                </p>
              </div>
              <div class="column">
                <div
                  :class="screen === 'mobile' ? 'text-24px' : 'is-size-3'"
                  class="has-text-centered-mobile"
                >
                  {{ $t('1,10,000+') }}
                </div>
                <p class="has-text-centered-mobile">
                  {{ $t('Jobseekers Registered') }}
                </p>
              </div>
            </div>
            <div class="columns is-flex">
              <div class="column">
                <div
                  :class="screen === 'mobile' ? 'text-24px' : 'is-size-3'"
                  class="has-text-centered-mobile"
                >
                  {{ $t('14,000+') }}
                </div>
                <p class="has-text-centered-mobile">
                  {{ $t('Success Stories') }}
                </p>
              </div>
              <div class="column">
                <div
                  :class="screen === 'mobile' ? 'text-24px' : 'is-size-3'"
                  class="has-text-centered-mobile"
                >
                  {{ $t('500') }}
                </div>
                <p class="has-text-centered-mobile">
                  {{ $t('Daily Application') }}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div>
              <div
                v-if="!signupSuccess"
                class="box border-24px"
                :class="screen === 'mobile' ? 'py-8' : 'pa-8'"
              >
                <div class="pb-4 has-text-centered-mobile">
                  <div
                    class="is-size-3 has-text-weight-normal line-height-40px"
                  >
                    {{ $t('Sign Up Today') }}
                  </div>
                  <span
                    class="has-text-weight-normal is-size-6 has-text-grey"
                    >{{ $t('Make you next hire with Rojgari Service') }}</span
                  >
                </div>
                <validation-observer ref="observer">
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('organizationName')"
                    rules="required|max:255|min:3"
                  >
                    <div class="field">
                      <input
                        v-model="formValues.organization_name"
                        :placeholder="$t('Organization Name')"
                        class="input"
                        type="text"
                      />
                      <p class="field-error help is-danger">
                        {{ errors[0] || fieldErrors.name }}
                      </p>
                    </div>
                  </validation-provider>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('mobileNumber')"
                    rules="required|digits:10|integer"
                  >
                    <div class="field">
                      <input
                        v-model="formValues.phone_number"
                        class="input"
                        type="text"
                        min="0"
                        :placeholder="$t('Mobile Number')"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                      />
                      <p class="field-error help is-danger">
                        {{ errors[0] || fieldErrors.phone_number }}
                      </p>
                    </div>
                  </validation-provider>
                  <div
                    class="is-flex"
                    :class="
                      screen === 'mobile' ? 'is-flex-direction-column' : 'gap-1'
                    "
                  >
                    <div
                      class="pa-0"
                      :class="screen === 'mobile' ? 'is-full-width' : 'w-half'"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('Industry')"
                        rules="required"
                      >
                        <div class="field industry">
                          <vue-auto-complete
                            v-model="formValues.industry"
                            :placeholder="$t('Industry')"
                            :showDropDownIcon="true"
                            :class="{
                              'is-danger': errors.length || fieldErrors.name
                            }"
                            item-text="name"
                            item-value="id"
                            endpoint="/api/v1/common/industries"
                          ></vue-auto-complete>
                          <p class="field-error help is-danger">
                            {{ errors[0] || get(fieldErrors, 'Industry') }}
                          </p>
                        </div>
                      </validation-provider>
                    </div>
                    <div
                      class="pa-0"
                      :class="screen === 'mobile' ? 'is-full-width' : 'w-half'"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('No. of Employees')"
                        rules="required"
                      >
                        <div class="dropdown is-active is-full-width">
                          <div class="dropdown-trigger is-full-width">
                            <button
                              class="pl-3 pr-2 button is-full-width select-item is-content-space-between"
                              :class="buttonClass"
                              aria-haspopup="true"
                              aria-controls="dropdown-menu"
                              @click="toggleDropdown = !toggleDropdown"
                            >
                              {{
                                $t(formValues.org_size) ||
                                $t('No. of Employees')
                              }}
                              <input
                                v-model="formValues.org_size"
                                :placeholder="$t('No. of Employees')"
                                class="autoCompleteInput input"
                                @focus="toggleDropdown = !toggleDropdown"
                                type="hidden"
                              /><vue-icon-base
                                height="16"
                                width="16"
                                :path="$options.icons[$kc('uni-down-arrow')]"
                                color="grey"
                              >
                              </vue-icon-base>
                            </button>
                          </div>
                          <div
                            v-if="toggleDropdown"
                            class="dropdown-menu is-full-width"
                            id="dropdown-menu"
                            role="menu"
                          >
                            <div class="dropdown-content">
                              <div
                                v-for="(owner, index) in employeeChoices"
                                :key="index"
                                :value="owner.value"
                                :hidden="owner.hidden"
                                class="has-text-black-light pointer pa-2"
                                @click="selectValue(owner.value)"
                              >
                                {{ owner.display_name }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <p class="field-error help is-danger">
                          {{ errors[0] || get(fieldErrors, 'org_size') }}
                        </p></validation-provider
                      >
                    </div>
                  </div>
                  <div
                    class="is-flex"
                    :class="
                      screen === 'mobile'
                        ? 'is-flex-direction-column '
                        : 'gap-1'
                    "
                  >
                    <div
                      class="pa-0"
                      :class="screen === 'mobile' ? 'is-full-width' : 'w-half'"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('password')"
                        rules="required|min:8"
                        vid="password"
                      >
                        <div class="field has-addons mb-0">
                          <div class="control is-expanded">
                            <input
                              v-model="formValues.password"
                              :type="showPassword ? 'text' : 'password'"
                              :placeholder="$t('Password')"
                              class="input"
                            />
                          </div>
                          <div class="control">
                            <a
                              class="button"
                              @click="showPassword = !showPassword"
                            >
                              <vue-icon-base
                                height="16"
                                width="16"
                                :path="
                                  $options.icons[
                                    $kc(
                                      showPassword ? 'uni-eye' : 'uni-eye-slash'
                                    )
                                  ]
                                "
                              >
                              </vue-icon-base>
                            </a>
                          </div>
                        </div>
                        <p class="field-error help is-danger">
                          {{ errors[0] || fieldErrors.password }}
                        </p>
                      </validation-provider>
                    </div>
                    <div
                      class="pa-0"
                      :class="screen === 'mobile' ? 'is-full-width' : 'w-half'"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('confirmPassword')"
                        rules="required|confirmed:password"
                      >
                        <div class="field has-addons mb-0">
                          <div class="control is-expanded">
                            <input
                              v-model="formValues.confirmPassword"
                              class="input"
                              :type="showConfirmPassword ? 'text' : 'password'"
                              :placeholder="$t('Confirm Password')"
                            />
                          </div>
                          <div class="control">
                            <a
                              class="button"
                              @click="
                                showConfirmPassword = !showConfirmPassword
                              "
                            >
                              <vue-icon-base
                                height="16"
                                width="16"
                                :path="
                                  $options.icons[
                                    $kc(
                                      showConfirmPassword
                                        ? 'uni-eye'
                                        : 'uni-eye-slash'
                                    )
                                  ]
                                "
                              >
                              </vue-icon-base>
                            </a>
                          </div>
                        </div>
                        <p class="field-error help is-danger">
                          {{ errors[0] || fieldErrors.password }}
                        </p>
                      </validation-provider>
                    </div>
                  </div>
                  <button
                    id="redirect-employer-register-btn"
                    class="button rounded is-employer has-text-white flex"
                    @click="signUp()"
                  >
                    <div>{{ $t('Sign Up') }}</div>
                    <vue-icon-base
                      class="ml-2"
                      height="16"
                      width="18"
                      :path="$options.icons[$kc('uni-arrow-right')]"
                    >
                    </vue-icon-base>
                  </button>
                </validation-observer>
              </div>
              <div
                v-else
                class="box px-10 border-24px has-margin-left-10-mobile has-margin-right-10-mobile"
              >
                <code-verification
                  :employerColor="true"
                  @redirectToEmployerOverview="verificationCode"
                ></code-verification>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="has-background-white padding-80px">
      <div class="container">
        <div class="is-flex is-flex-direction-column">
          <div
            :class="
              screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
            "
          >
            <h3
              class="employer is-size-1 is-size-3-mobile has-text-centered line-height-54px"
            >
              {{ $t('Available Jobseekers') }}
            </h3>
            <p class="has-text-centered has-text-grey-light px-3">
              {{ $t('Currently available workers with us') }}
            </p>
            <div
              class="is-flex content-center gap-1 is-flex-wrap py-10"
              :class="screen === 'mobile' ? '' : 'px-5'"
            >
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Waiter/ Waitress') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Barista') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Security guard') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Allrounder Cook') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('kitchen Helper') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Front desk officer') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Cleaner') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Storekeeper') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Delivery rider') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Office runner') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Electrician') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('housekeeping') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Cashier') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Office Assistant') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('bartender') }}
              </p>
              <p
                :class="screen === 'mobile' ? 'tag-color-mobile' : 'tag-color'"
              >
                {{ $t('Accountant') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-light-brown padding-80-80px">
      <div class="container">
        <div
          class="columns"
          :class="
            screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
          "
        >
          <div
            class="column is-flex is-flex-direction-column content-center"
            :class="screen === 'mobile' ? ' align-center' : ''"
          >
            <div
              :class="screen === 'mobile' ? 'is-size-3' : 'is-size-1'"
              class="px-5 has-text-centered-mobile"
            >
              {{ $t('Success Story') }}
            </div>
            <p
              class="has-text-color-grey-light has-text-centered-mobile"
              :class="screen === 'mobile' ? '' : 'px-5'"
              v-html="
                $t(
                  'For nearly four years, Puja Ghimire, the founder of Springville Pre-School, had been searching for a reliable driver for her school. Understanding the importance of safe and dependable transportation for the students, she was actively looking for various means to find a suitable driver then she came across Rojgari.com and learned about its services.'
                )
              "
            ></p>
            <button
              id="know-more-btn"
              :class="screen === 'mobile' ? 'widht-50' : 'width-1by4'"
              class="button rounded is-employer has-text-white mt-5 ml-4"
              @click="
                $router.push(
                  localePath({
                    name: 'employer-zone'
                  })
                )
              "
            >
              <div>{{ $t('Know More') }}</div>
            </button>
          </div>
          <div class="column">
            <iframe
              class="rounded-10 fill-height is-full-width min-height-21rem"
              src="https://www.youtube.com/embed/rmIjeVUyONI"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="has-background-white padding-80px">
      <div class="container">
        <div
          class="columns align-center"
          :class="
            screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
          "
        >
          <div class="column is-flex content-center">
            <img
              :src="`/images/account/rojgariPhone.png`"
              class="height-32rem width-16rem"
              :class="screen === 'mobile' ? 'img-mobile' : ''"
            />
          </div>
          <div
            class="column height-auto"
            :class="screen === 'mobile' ? '' : 'px-5'"
          >
            <span
              class="is-size-1 is-size-3-mobile has-text-centered pb-5 has-text-centered-mobile"
              style="line-height: 60px"
              >{{ $t('Post job and get jobseeker you like') }}
            </span>
            <div class="line is-relative mt-4" style="z-index: 10">
              <div
                v-for="step in employerSteps"
                :key="step.id"
                class="is-flex gap-1 mb-6 align-center is-relative"
              >
                <div class="is-flex align-center content-center line-box">
                  {{ step.id }}
                </div>
                <div class="has-text-weight-normal">
                  {{ step.step }}
                </div>
              </div>
            </div>
            <hr class="hr-line has-background-black mt-8 mb-5" />
            <p>
              {{
                $t('* Fees (including VAT) for this service can be paid online')
              }}
            </p>
            <button
              id="btn-post-a-job"
              class="button rounded is-employer has-text-white flex mt-5"
              @click="gotoJobpost()"
            >
              <div>{{ $t('Post Job') }}</div>
              <vue-icon-base
                class="ml-2"
                height="16"
                width="18"
                :path="$options.icons[$kc('uni-arrow-right')]"
              >
              </vue-icon-base>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="has-background-white padding-80px bg-light-grey is-flex gap-4 is-flex-direction-column"
    >
      <top-employer
        showDifferentTitle="Employers who are using our service"
        :class="
          screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
        "
      ></top-employer>
    </div>
    <div class="has-background-white padding-80px has-background-black py-8">
      <div class="container">
        <div
          class="is-flex align-center content-center gap-2"
          :class="
            screen === 'mobile'
              ? 'is-flex-direction-column'
              : 'padding-right-70px padding-left-70px'
          "
        >
          <div class="has-text-white is-size-4">
            {{ $t('Download Now') }}
          </div>
          <a
            id="btn-download"
            class="pointer height-60px"
            href="https://play.google.com/store/apps/details?id=com.rojgaripasal.rojgariapp"
            target="_blank"
          >
            <img
              src="/images/account/android_download.png"
              class="height-60px"
            />
          </a>
          <a
            class="pointer height-60px"
            href="https://apps.apple.com/us/app/rojgari/id1493964641?ign-mpt=uo%3D2"
            target="_blank"
          >
            <img src="/images/account/apple_download.png" class="height-60px" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import formMixin from '@/mixins/veeValidate'
import VueAutoComplete from '@/components/Commons/VueAutoComplete'
import VueIconBase from '@/components/Commons/VueIconBase'
import { mapGetters, mapMutations } from 'vuex'
import {
  uniEye,
  uniEyeSlash,
  uniArrowRight,
  uniGooglePlay,
  uniApple,
  uniDownArrow
} from '@/helpers/icons'
import CodeVerification from '../Accounts/SignUp/CodeVerification.vue'
import TopEmployer from '../Homepage/TopEmployer.vue'
export default {
  icons: {
    uniEye,
    uniEyeSlash,
    uniArrowRight,
    uniGooglePlay,
    uniApple,
    uniDownArrow
  },
  components: {
    VueAutoComplete,
    VueIconBase,
    CodeVerification,
    TopEmployer
  },
  mixins: [formMixin],
  data() {
    return {
      buttonClass: ' has-text-grey-light',
      toggleDropdown: false,
      signupSuccess: false,
      employerSteps: [
        { id: 1, step: this.$t('Create an employer profile') },
        { id: 2, step: this.$t('Click on the post-job & fill details') },
        { id: 3, step: this.$t('Get the job application') },
        { id: 4, step: this.$t('Select the preferred worker') }
      ],
      employedJobseeker: '12K',
      showPassword: false,
      showConfirmPassword: false,
      formValues: {
        organization_name: '',
        phone_number: '',
        registration_medium: '',
        country: '',
        country_code: '+977',
        password: '',
        confirmPassword: '',
        email: '',
        industry: '',
        org_size: '',
        otp: ''
      },
      employeeChoices: [
        {
          value: '',
          display_name: this.$t('No. of Employees'),
          hidden: 'hidden',
          selected: 'selected'
        },
        {
          value: '1 - 10 employees',
          display_name: this.$t('1 - 10 employees')
        },
        {
          value: '10 - 50 employees',
          display_name: this.$t('10 - 50 employees')
        },
        {
          value: '50 - 100 employees',
          display_name: this.$t('50 - 100 employees')
        },
        {
          value: '100 - 200 employees',
          display_name: this.$t('100 - 200 employees')
        },
        {
          value: '200 - 500 employees',
          display_name: this.$t('200 - 500 employees')
        },
        {
          value: '500 - 1000 employees',
          display_name: this.$t('500 - 1000 employees')
        },
        {
          value: '1000+ employees',
          display_name: this.$t('1000+ employees')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      screen: 'getScreen',
      currentPhoneNumber: 'signup/currentPhoneNumber'
    })
  },
  mounted() {
    if (this.currentPhoneNumber) {
      this.formValues.phone_number = this.currentPhoneNumber
    }
    if (this.$auth.loggedIn) {
      this.$router.push(
        this.localePath({
          name: `jobseeker-profile-id`,
          params: { id: 'me' },
          query: { tab: 'applied-jobs' }
        })
      )
    }
  },
  methods: {
    selectValue(value) {
      this.formValues.org_size = value
      this.toggleDropdown = false
      this.buttonClass = 'has-text-black-light'
    },
    ...mapMutations({ updatePhoneNumber: 'signup/updatePhoneNumber' }),
    async signUp() {
      if (await this.validateAllFields()) {
        this.updatePhoneNumber(this.formValues.phone_number)
        const endpoint = '/api/v1/users/redirected-employer-register/'
        if (this.formValues.country_code === '+977') {
          this.$axios
            .$post(endpoint, {
              name: this.formValues.organization_name,
              industry: this.formValues.industry,
              org_size: this.formValues.org_size,
              phone_number: this.currentPhoneNumber,
              password: this.formValues.password,
              country: this.currentCountryName,
              registration_medium: 'web'
            })
            .then(response => {
              if (
                response.status === 'Success' ||
                response.phone_number.substring(4, 14) ===
                  this.formValues.phone_number
              ) {
                this.$axios
                  .$post('/api/v1/auth/generate-otp/', {
                    phone_number: '977-' + this.formValues.phone_number
                  })
                  .then(result => {
                    this.signupSuccess = true
                    this.notifyUser(this.$t('verificationCodeSent'))
                  })
              }
            })
            .catch(error => {
              if (error) {
                this.getError(error)
              }
            })
        }
      }
    },
    verificationCode() {
      this.$auth
        .loginWith('local', {
          data: {
            phone_number: this.formValues.phone_number,
            password: this.formValues.password
          }
        })
        .then(response => {
          this.handleLogin()
        })
    },
    handleLogin() {
      this.$router.push(
        this.localePath({
          name: `employer-profile-id`,
          params: { id: 'me' },
          query: { tab: 'active-jobs' }
        })
      )
    },
    gotoJobpost() {
      if (this.$auth.loggedIn && this.$auth.user.employer_profile) {
        if (this.$auth.user.has_filled_initial_form) {
          if (
            this.$auth.user.related_organizations.length &&
            this.$auth.user.is_purchase_available
          ) {
            this.$nuxt.$emit('openinitialform')
          } else if (!this.$auth.user.is_purchase_available) {
            this.$router.push(
              this.localePath({
                name: 'pricing'
              })
            )
          } else {
            this.setDialog({ display: true, type: 'details' })
            this.notifyError(this.$t('Initial profile form not filled'))
          }
        } else {
          this.setDialog({ display: true, type: 'details' })
          this.notifyError(this.$t('Initial profile form not filled'))
        }
      } else {
        this.setDialog({
          display: true,
          type: 'employer-sign-in',
          extraInfo: 'employer-sign-in'
        })
        this.notifyError(
          this.$t('You need to login as an employer to post a job.')
        )
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Tiro+Devanagari+Hindi&display=swap');
section {
  font-family: 'Tiro Devanagari Hindi', serif;
}
.img-mobile {
  width: 159.503px;
  height: 345.121px;
  flex-shrink: 0;
}
.field {
  margin-bottom: 0 !important;
}
.line::before {
  content: '';
  position: absolute;
  top: 0;
  left: 1rem;
  height: 100%;
  width: 1px;
  background-color: #dddddd;
}

.line-box {
  height: 2rem;
  width: 2rem;
  border-radius: 0.8rem;
  background-color: #faefea;
}
.padding-80px,
.padding-80-80px {
  padding: 80px;
}

@media screen and (max-width: 769px) {
  .padding-80px,
  .padding-80-80px {
    padding: 40px;
  }
}

@media screen and (max-width: 429px) {
  .padding-80px,
  .padding-80-80px {
    padding: 40px 16px;
  }
}
.autoCompleteInput {
  border: none;
  box-shadow: none;
  display: hidden;
}

.industry * div {
  padding-left: 0 !important;
}
</style>
